if (!customElements.get("size-range")) {
  customElements.define(
    "size-range",
    class SizeRange extends HTMLElement {
      constructor() {
        super();

        this.config = JSON.parse(
          this.querySelector("[data-config]").textContent
        );

        this.min = this.config.min;
        this.max = this.config.max;

        this.rangeMin = this.querySelector('input[type="range"]:first-child');
        this.rangeMax = this.querySelector('input[type="range"]:last-child');
        this.inputMin = this.querySelector("[data-input-min]");
        this.inputMax = this.querySelector("[data-input-max]");
        this.paramInputs = this.querySelectorAll(
          `[name="${this.config.paramName}"]`
        );

        this.inputMin.addEventListener("focus", this.inputMin.select);
        this.inputMax.addEventListener("focus", this.inputMax.select);
        this.inputMin.addEventListener(
          "change",
          this.onInputMinChange.bind(this)
        );
        this.inputMax.addEventListener(
          "change",
          this.onInputMaxChange.bind(this)
        );

        this.rangeMin.addEventListener(
          "change",
          this.onRangeMinChange.bind(this)
        );
        this.rangeMax.addEventListener(
          "change",
          this.onRangeMaxChange.bind(this)
        );
        this.rangeMin.addEventListener(
          "input",
          this.onRangeMinInput.bind(this)
        );
        this.rangeMax.addEventListener(
          "input",
          this.onRangeMaxInput.bind(this)
        );
      }

      updateParamInputs() {
        this.paramInputs.forEach((input) => {
          const value = Number(input.value);

          input.disabled = value > this.max || value < this.min;
        });
      }

      onInputMinChange(event) {
        event.preventDefault();

        this.min = Number(event.target.value);
        this.updateParamInputs();

        event.target.value = Math.max(
          Math.min(
            parseInt(event.target.value),
            parseInt(this.inputMax.value || event.target.max) - 1
          ),
          event.target.min
        );
        this.rangeMin.value = event.target.value;
        this.rangeMin.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max)) * 100
          }%`
        );
      }

      onInputMaxChange(event) {
        event.preventDefault();

        this.max = Number(event.target.value);
        this.updateParamInputs();

        event.target.value = Math.min(
          Math.max(
            parseInt(event.target.value),
            parseInt(this.inputMin.value || event.target.min) + 1
          ),
          event.target.max
        );
        this.rangeMax.value = event.target.value;
        this.rangeMax.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max)) * 100
          }%`
        );
      }

      onRangeMinChange(event) {
        event.stopPropagation();

        this.min = Number(event.target.value);
        this.updateParamInputs();

        this.inputMin.value = event.target.value;
        this.inputMin.dispatchEvent(new Event("change", { bubbles: true }));
      }

      onRangeMaxChange(event) {
        event.stopPropagation();

        this.max = Number(event.target.value);
        this.updateParamInputs();

        this.inputMax.value = event.target.value;
        this.inputMax.dispatchEvent(new Event("change", { bubbles: true }));
      }

      onRangeMinInput(event) {
        event.target.value = Math.min(
          parseInt(event.target.value),
          parseInt(this.inputMax.value || event.target.max) - 1
        );
        event.target.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.inputMin.value = event.target.value;
      }

      onRangeMaxInput(event) {
        event.target.value = Math.max(
          parseInt(event.target.value),
          parseInt(this.inputMin.value || event.target.min) + 1
        );
        event.target.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.inputMax.value = event.target.value;
      }
    }
  );
}
